export default __webpack_public_path__ + "static/media/logo-opera.ff14e476.svg";